import { render } from "./DappBlock.vue?vue&type=template&id=3eb77868&scoped=true&ts=true"
import script from "./DappBlock.vue?vue&type=script&lang=ts"
export * from "./DappBlock.vue?vue&type=script&lang=ts"

import "./DappBlock.vue?vue&type=style&index=0&id=3eb77868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb77868"]])

export default __exports__